// Direct-download URL for the Atlas Desktop installer.
// Relative so it resolves to whichever host (dev/stage/prod) served the page.
// In production this is published by desktop-release.yml to /var/www/atlas-downloads/
// and served via an nginx alias:  location /downloads/ { alias /var/www/atlas-downloads/; }
export const DESKTOP_DOWNLOAD_URL = '/downloads/atlas-setup.exe';

// Programmatically trigger the installer download (used by the sidebar banner).
export function triggerDesktopDownload(): void {
  const a = document.createElement('a');
  a.href = DESKTOP_DOWNLOAD_URL;
  a.download = 'atlas-setup.exe';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
